module.exports = __webpack_public_path__ + "img/pic_one.4bb7b574.png";